import React, { useState } from "react";
import Icons from "../myIcon/Icons";
import { Link } from "react-router-dom";
import MenulistAbout from "./MenulistAbout";
import MenulistAdmission from "./MenulistAdmission";
import MenulistLearning from "./MenulistLearning";
import MenulistAcademics from "./MenulistAcademics";
import MenulistPastoral from "./MenulistPastoral";
import MenulistClassroom from "./MenulistClassroom";
import MenulistCommunity from "./MenulistCommunity";
import MenulistResources from "./MenulistResources";
import MenulistBranches from "./MenulistBranches";
import MenulistSectorC from "./MenulistSectorC";

export default function Menu({isOpen, setIsOpen}) {
    const handleLinkClick = () => {
        setIsOpen(false); 
    };

    const [openInner, setOpenInner] = useState(null);
    const [showSearch, setShowSearch] = useState(false);

  return (
    <>
    <section className={isOpen ? "mobilemenu-area open-menu" : "mobilemenu-area close-menu"}>
        <div className="menu-header">
            <div>
                <button className="menu-close-btn" onClick={() =>{setOpenInner(false); setIsOpen(false); setShowSearch(false);}} aria-label="Close menu">✕</button>
                <Link to={"/contact"} className='default-btn' onClick={() => {handleLinkClick(); setOpenInner(null);  setShowSearch(false);}}>
                    <div><span>Contact Us</span><span>Contact Us</span></div>
                </Link>
            </div>
            <ul className="menu-social">
                <li><Link to={"https://www.facebook.com/lpscpsingh/"} target="_blank" aria-label="Facebook"><Icons name="facebook"/></Link></li>
                <li><Link to={"https://www.instagram.com/lucknow_public_school/"} target="_blank" aria-label="instagram"><Icons name="instagram"/></Link></li>
                <li><Link to={"https://www.youtube.com/@lucknowpublicschoolofficial"} target="_blank" aria-label="youtube"><Icons name="youtube"/></Link></li>
                {/* <li><Link onClick={() => setShowSearch(true)} aria-label="search"><Icons name="search"/></Link></li> */}
            </ul>
        </div>

        <div className="menu-leftside">
            <ul className="menu-mainlink">
                <li><Link onClick={() => {setOpenInner("branch-4");}}>Sector-D, Lucknow <Icons name="plus"/></Link></li>
                <li><Link onClick={() => {setOpenInner("branch-5");}}>Sector-I, Lucknow<Icons name="plus"/></Link></li>
                <li><Link onClick={() => {setOpenInner("branch-10");}}>Jankipuram, Lucknow <Icons name="plus"/></Link></li>
                <li><Link onClick={() => {setOpenInner("branch-8");}}>South City, Lucknow <Icons name="plus"/></Link></li>
                <li><Link onClick={() => {setOpenInner("branch-1");}}>Eldeco II, Lucknow <Icons name="plus"/></Link></li>
                <li><Link onClick={() => {setOpenInner("branch-2");}}>Ansal API, Lucknow <Icons name="plus"/></Link></li>
                <li><Link onClick={() => {setOpenInner("branch-3");}}>Ahiyaraipur, Raebareli <Icons name="plus"/></Link></li>
                <li><Link onClick={() => {setOpenInner("branch-9");}}>Pragatipuram, Raebareli <Icons name="plus"/></Link></li>
                <li><Link onClick={() => {setOpenInner("branch-6");}}>Sector-B, Unnao <Icons name="plus"/></Link></li>
                <li><Link onClick={() => {setOpenInner("branch-7");}}>Sector-C, Unnao <Icons name="plus"/></Link></li>
            </ul>

            <div className={openInner ? "menu-overlay hide-menulink" : "menu-overlay"}></div>
        </div>

        <div className="menu-rightside">
            <div className="menu-keylink">
                <h4 className="heading">Key Links</h4>
                <ul>
                    <li><Link to={"/why-lps-lucknow-public-school"} onClick={() => {handleLinkClick(); setOpenInner(null);  setShowSearch(false);}}>why LPS</Link></li>
                    <li><Link to={"/news"} onClick={() => {handleLinkClick(); setOpenInner(null); setShowSearch(false);}}>Media</Link></li>
                    <li><Link to={"/teacher"} onClick={() => {handleLinkClick(); setOpenInner(null); setShowSearch(false);}}>teacher</Link></li>
                    <li><Link to={"/student"} onClick={() => {handleLinkClick(); setOpenInner(null); setShowSearch(false);}}>student life</Link></li>
                    <li><Link to={"/parents"} onClick={() => {handleLinkClick(); setOpenInner(null);setShowSearch(false);}}>Parents</Link></li>
                    <li><Link to={"/alumni"} onClick={() => {handleLinkClick(); setOpenInner(null);setShowSearch(false);}}>Alumni</Link></li>
                </ul>
            </div>
        </div>

        <div className={openInner ? "mobilemenu-inner open-inner" : "mobilemenu-inner"}>
            <div className="menu-innerpage">
                <Link onClick={() => setOpenInner(null)} className="menu-back"><Icons name="Longarrow_left"/> Back</Link>
                
                {openInner === "branch-1" && <MenulistBranches/>}
                {openInner === "branch-2" && <MenulistAbout />}
                {openInner === "branch-3" && <MenulistAdmission/>}
                {openInner === "branch-4" && <MenulistLearning/>}
                {openInner === "branch-5" && <MenulistAcademics/>}
                {openInner === "branch-6" && <MenulistPastoral/>}
                {openInner === "branch-7" && <MenulistClassroom/>}
                {openInner === "branch-8" && <MenulistCommunity/>}
                {openInner === "branch-9" && <MenulistResources/>}
                {openInner === "branch-10" && <MenulistSectorC/>}
            </div>
        </div>

        <div className={`search-bar ${showSearch ? 'show' : ''}`}>
            <Icons name="search"/>
            <input type="text" name="search" id="search" placeholder="Search" />
            <span onClick={() => setShowSearch(false)}><Icons name="cross"/></span>
        </div>
    </section>
    </>
  )
}